import React from 'react';
import $ from 'jquery';
import {IMetrics} from '../core/models/metrics';
import {metricsEvent} from '../core/classes/api';

import '../styles/sliver.scss';

interface IProps {
     data: {
          campaign:string;
          type:string;
          backgroundLink: string;
          mobileBackgroundLink:string;
          dataTrigger:string;
          content: {
               title: string;
               subTitle: string;
               footer: {
                    button: {
                         text: string;
                         link: string;
                    }
               }
          }
     }
}

interface State {
     backgroundLink:string;
     mobileWidth: number;
}
class SliverBanner extends React.Component<IProps, State> {
     state:State = {
          backgroundLink: '',
          mobileWidth: 767
     }
     constructor(props: IProps) {
          super(props);
          this.handleScroll = this
               .handleScroll
               .bind(this);
          this.renderHtml = this
               .renderHtml
               .bind(this);
          this.metricHandler = this.metricHandler.bind(this);
          this.handleWidth = this.handleWidth.bind(this);                   
     }

     componentDidMount() {
          const {backgroundLink, mobileBackgroundLink} = this.props.data;
          const {mobileWidth} = this.state;
          window.addEventListener('scroll', this.handleScroll);
          setTimeout(() => {
               const container = document.getElementById('sliver-container') as HTMLElement;
               const component = document.getElementById('sliverComponent') as HTMLElement;
               container.appendChild(component);
          }, 900);
          window.addEventListener('resize', this.handleWidth);
          (window.innerWidth < mobileWidth && mobileBackgroundLink && mobileBackgroundLink !== '') ? this.setState({...this.state, backgroundLink: mobileBackgroundLink}):this.setState({...this.state, backgroundLink: backgroundLink})
     }

     public handleWidth(){
          const {mobileWidth} = this.state;
          const {backgroundLink, mobileBackgroundLink} = this.props.data;
          (window.innerWidth < mobileWidth && mobileBackgroundLink && mobileBackgroundLink !== '')?this.setState({...this.state, backgroundLink: mobileBackgroundLink}):this.setState({...this.state, backgroundLink: backgroundLink});
     }

     public metricHandler(e:any){
          // e.preventDefault();
          const event:IMetrics = {
               category: this.props.data.type,
               referer: window.location.href,
               campaign: this.props.data.campaign,
               action: 'cta taken'
          }
          metricsEvent(event);
     }

     public handleScroll() {
          const height = $('#sliver-container').height() || '';
          if (window.scrollY > 400) {
               $('#sliver-container').addClass('fix-sliverbanner');
               $('.nav-container-scrolled').css('top', height);
          } else if (window.scrollY < 401) {
               $('#sliver-container').removeClass('fix-sliverbanner');
               $('.nav-container-scrolled').css('top', '0px');
          }
     }

     public renderHtml(data: any) {
          return { __html: data };
     }
     public render() {
          const {backgroundLink} = this.state;
          return (
               <div className="sliver-banner sliverBannerComp" id="sliverComponent">
                    <a href={this.props.data.content.footer.button.link} data-trigger={this.props.data.dataTrigger}>
                         <img data-trigger={this.props.data.dataTrigger} src={backgroundLink} alt="sliver" />                        
                    </a> 
                     {/* 
                     <div className="row text-holder-sliver">
                         <h2 className="text-center">
                              <a
                                   onClick={this.metricHandler}
                                   href={this.props.data.content.footer.button.link}
                                   data-trigger={this.props.data.dataTrigger}>
                                   <span className="headline " dangerouslySetInnerHTML={this.renderHtml(this.props.data.content.title)}/>&nbsp;<span className="headline no-uppercase" dangerouslySetInnerHTML={this.renderHtml(this.props.data.content.subTitle)}/>
                                   {/* <span
                                        style={{
                                             color: '#ffffff',
                                             fontWeight: 400
                                        }}
                                        dangerouslySetInnerHTML={this.renderHtml(this.props.data.content.subTitle)} /> 
                              </a>
                         </h2>
                    </div> 
                     */}
               </div>
          );
     }
}

export default SliverBanner;